/*
 * Module for the learner button on the dashboard
 */

define([
  "marionette",
  "messaging/messenger",
  "moment",
  "modules/dashboard/dashboardLearner/dashboardLearnerView",
], function (Marionette, Messenger, Moment, DashboardLearnerView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "dashboardLearner";
      this.region = options.region;
    },
    show: function (touchpointId, localeId) {
      const daysBack = new Date().getDefaultDaysBack();
      const emergingTopicThreshold = Messenger.reqres.request("emerging:topic:threshold");
      const parameters = {
        touchpoint: touchpointId,
        startDate: new Moment().subtract(daysBack, "days").startOf("day").valueOf(), //get start date to be 30 days back (get rid of hardcoding?)
        endDate: new Moment().startOf("day").valueOf(),
        localeId: localeId,
        size: emergingTopicThreshold,
      };
      const noMatchCount = Messenger.reqres.request("learner:emerging:count", parameters);
      this.view = new DashboardLearnerView.dashboardLearnerView({ model: noMatchCount });

      //when the user clicks on the button, send them to the learner and execute the search using the default parameters
      this.view.on(
        "click:button",
        function () {
          //no need to save when we navigate away since there's nothing to save on the dashboard
          Messenger.vent.trigger("show:learner:and:search", touchpointId, localeId);
        },
        this,
      );
      this.showRegion(this.view);
    },
  });
});
